export const BIBLE_VERSES = 
[
  {
    "text": "No princípio Deus criou os céus e a terra.",
    "reference": "Gênesis 1:1"
  },
  {
    "text": "Criou Deus o homem à sua imagem, à imagem de Deus o criou; homem e mulher os criou.",
    "reference": "Gênesis 1:27"
  },
  {
    "text": "Então o Senhor Deus formou o homem do pó da terra e soprou em suas narinas o fôlego de vida, e o homem se tornou um ser vivente.",
    "reference": "Gênesis 2:7"
  },
  {
    "text": "Farei de você um grande povo, e o abençoarei. Tornarei famoso o seu nome, e você será uma bênção.",
    "reference": "Gênesis 12:2"
  },
  {
    "text": "Abrão creu no Senhor, e isso lhe foi creditado como justiça.",
    "reference": "Gênesis 15:6"
  },
  {
    "text": "Disse o Senhor: \"De fato tenho visto a opressão sobre o meu povo no Egito, e também tenho escutado o seu clamor, por causa dos seus feitores, e sei quanto eles estão sofrendo.",
    "reference": "Êxodo 3:7"
  },
  {
    "text": "e os israelitas atravessaram pelo meio do mar em terra seca, tendo uma parede de água à direita e outra à esquerda.",
    "reference": "Êxodo 14:22"
  },
  {
    "text": "Não terás outros deuses além de mim.",
    "reference": "Êxodo 20:3"
  },
  {
    "text": "Como é feliz aquele que não segue o conselho dos ímpios, não imita a conduta dos pecadores, nem se assenta na roda dos zombadores!",
    "reference": "Salmo 1:1"
  },
  {
    "text": "É como árvore plantada à beira de águas correntes: Dá fruto no tempo certo e suas folhas não murcham. Tudo o que ele faz prospera!",
    "reference": "Salmo 1:3"
  },
  {
    "text": "O Senhor é o meu pastor; de nada terei falta.",
    "reference": "Salmo 23:1"
  },
  {
    "text": "Em verdes pastagens me faz repousar e me conduz a águas tranqüilas;",
    "reference": "Salmo 23:2"
  },
  {
    "text": "restaura-me o vigor. Guia-me nas veredas da justiça por amor do seu nome.",
    "reference": "Salmo 23:3"
  },
  {
    "text": "Mesmo quando eu andar por um vale de trevas e morte, não temerei perigo algum, pois tu estás comigo; a tua vara e o teu cajado me protegem.",
    "reference": "Salmo 23:4"
  },
  {
    "text": "Preparas um banquete para mim à vista dos meus inimigos. Tu me honras, ungindo a minha cabeça com óleo e fazendo transbordar o meu cálice.",
    "reference": "Salmo 23:5"
  },
  {
    "text": "Sei que a bondade e a fidelidade me acompanharão todos os dias da minha vida, e voltarei à casa do Senhor enquanto eu viver.",
    "reference": "Salmo 23:6"
  },
  {
    "text": "O Senhor é a minha luz e a minha salvação; de quem terei temor? O Senhor é o meu forte refúgio; de quem terei medo?",
    "reference": "Salmo 27:1"
  },
  {
    "text": "Espere no Senhor. Seja forte! Coragem! Espere no Senhor.",
    "reference": "Salmo 27:14"
  },
  {
    "text": "Deleite-se no Senhor, e ele atenderá aos desejos do seu coração.",
    "reference": "Salmo 37:4"
  },
  {
    "text": "Entregue o seu caminho ao Senhor; confie nele, e ele agirá:",
    "reference": "Salmo 37:5"
  },
  {
    "text": "Deus é o nosso refúgio e a nossa fortaleza, auxílio sempre presente na adversidade.",
    "reference": "Salmo 46:1"
  },
  {
    "text": "Parem de lutar! Saibam que eu sou Deus! Serei exaltado entre as nações, serei exaltado na terra. ",
    "reference": "Salmo 46:10"
  },
  {
    "text": "Aquele que habita no abrigo do Altíssimo e descansa à sombra do Todo-poderoso",
    "reference": "Salmo 91:1"
  },
  {
    "text": "pode dizer ao Senhor: Tu és o meu refúgio e a minha fortaleza, o meu Deus, em quem confio.",
    "reference": "Salmo 91:2"
  },
  {
    "text": "Confie no Senhor de todo o seu coração e não se apóie em seu próprio entendimento;",
    "reference": "Provérbios 3:5"
  },
  {
    "text": "reconheça o Senhor em todos os seus caminhos, e ele endireitará as suas veredas.",
    "reference": "Provérbios 3:6"
  },
  {
    "text": "Em seu coração o homem planeja o seu caminho, mas o Senhor determina os seus passos.",
    "reference": "Provérbios 16:9"
  },
  {
    "text": "Instrua a criança segundo os objetivos que você tem para ela, e mesmo com o passar dos anos não se desviará deles.",
    "reference": "Provérbios 22:6"
  },
  {
    "text": "mas aqueles que esperam no Senhor renovam as suas forças. Voam bem alto como águias; correm e não ficam exaustos, andam e não se cansam.",
    "reference": "Isaías 40:31"
  },
  {
    "text": "Por isso não tema, pois estou com você; não tenha medo, pois sou o seu Deus. Eu o fortalecerei e o ajudarei; Eu o segurarei com a minha mão direita vitoriosa.",
    "reference": "Isaías 41:10"
  },
  {
    "text": "Ele foi oprimido e afligido, contudo não abriu a sua boca; como um cordeiro foi levado para o matadouro, e como uma ovelha que diante de seus tosquiadores fica calada, ele não abriu a sua boca.",
    "reference": "Isaías 53:7"
  },
  {
    "text": "assim também ocorre com a palavra que sai da minha boca: Ela não voltará para mim vazia, mas fará o que desejo e atingirá o propósito para o qual a enviei.",
    "reference": "Isaías 55:11"
  },
  {
    "text": "Porque sou eu que conheço os planos que tenho para vocês\", diz o Senhor, \"planos de fazê-los prosperar e não de lhes causar dano, planos de dar-lhes esperança e um futuro.",
    "reference": "Jeremias 29:11"
  },
  {
    "text": "Vocês me procurarão e me acharão quando me procurarem de todo o coração.",
    "reference": "Jeremias 29:13"
  },
  {
    "text": "Porque Deus tanto amou o mundo que deu o seu Filho Unigênito, para que todo o que nele crer não pereça, mas tenha a vida eterna.",
    "reference": "João 3:16"
  },
  {
    "text": "Bem-aventurados os que choram, pois serão consolados.",
    "reference": "Mateus 5:4"
  },
  {
    "text": "Bem-aventurados os pacificadores, pois serão chamados filhos de Deus.",
    "reference": "Mateus 5:9"
  },
  {
    "text": "Busquem, pois, em primeiro lugar o Reino de Deus e a sua justiça, e todas essas coisas lhes serão acrescentadas.",
    "reference": "Mateus 6:33"
  },
  {
    "text": "Venham a mim, todos os que estão cansados e sobrecarregados, e eu lhes darei descanso.",
    "reference": "Mateus 11:28"
  },
  {
    "text": "Alegrem-se sempre no Senhor. Novamente direi: alegrem-se!",
    "reference": "Filipenses 4:4"
  },
  {
    "text": "Tudo posso naquele que me fortalece.",
    "reference": "Filipenses 4:13"
  },
  {
    "text": "O meu Deus suprirá todas as necessidades de vocês, de acordo com as suas gloriosas riquezas em Cristo Jesus.",
    "reference": "Filipenses 4:19"
  },
  {
    "text": "Sabemos que Deus age em todas as coisas para o bem daqueles que o amam, dos que foram chamados de acordo com o seu propósito.",
    "reference": "Romanos 8:28"
  },
  {
    "text": "Pois estou convencido de que nem morte nem vida, nem anjos nem demônios, nem o presente nem o futuro, nem quaisquer poderes,",
    "reference": "Romanos 8:38-39"
  },
  {
    "text": "O amor é paciente, o amor é bondoso. Não inveja, não se vangloria, não se orgulha.",
    "reference": "1 Coríntios 13:4"
  },
  {
    "text": "Assim, permanecem agora estes três: a fé, a esperança e o amor. O maior deles, porém, é o amor.",
    "reference": "1 Coríntios 13:13"
  },
  {
    "text": "Não fui eu que lhe ordenei? Seja forte e corajoso! Não se apavore, nem se desanime, pois o Senhor, o seu Deus, estará com você por onde você andar\".",
    "reference": "Josué 1:9"
  },
  {
    "text": "Pois a palavra de Deus é viva e eficaz, e mais afiada que qualquer espada de dois gumes; ela penetra ao ponto de dividir alma e espírito, juntas e medulas, e julga os pensamentos e intenções do coração.",
    "reference": "Hebreus 4:12"
  },
  {
    "text": "Ora, a fé é a certeza daquilo que esperamos e a prova das coisas que não vemos.",
    "reference": "Hebreus 11:1"
  },
  {
    "text": "Não é o caso dos ímpios! São como palha que o vento leva.",
    "reference": "Salmos 1:4"
  },
  {
    "text": "Por que se amotinam as nações e os povos tramam em vão?",
    "reference": "Salmos 2:1"
  },
  {
    "text": "Beijem o filho, para que ele não se ire e vocês não sejam destruídos de repente, pois num instante acende-se a sua ira. Como são felizes todos os que nele se refugiam!",
    "reference": "Salmos 2:12"
  },
  {
    "text": "Senhor, muitos são os meus adversários! Muitos se rebelam contra mim!",
    "reference": "Salmos 3:1"
  },
  {
    "text": "Eu me deito e durmo, e torno a acordar, porque é o Senhor que me sustém.",
    "reference": "Salmos 3:5"
  },
  {
    "text": "Responde-me quando clamo, ó Deus que me faz justiça! Dá-me alívio da minha angústia; Tem misericórdia de mim e ouve a minha oração.",
    "reference": "Salmos 4:1"
  },
  {
    "text": "Ofereçam sacrifícios como Deus exige e confiem no Senhor.",
    "reference": "Salmos 4:5"
  },
  {
    "text": "Escuta, Senhor, as minhas palavras, considera o meu gemer.",
    "reference": "Salmos 5:1"
  },
  {
    "text": "Eu, porém, pelo teu grande amor, entrarei em tua casa; com temor me inclinarei para o teu santo templo.",
    "reference": "Salmos 5:7"
  },
  {
    "text": "Pois tu, Senhor, abençoas o justo; o teu favor o protege como um escudo.",
    "reference": "Salmos 5:12"
  },
  {
    "text": "Senhor, não me castigues na tua ira nem me disciplines no teu furor.",
    "reference": "Salmos 6:1"
  },
  {
    "text": "Estou exausto de tanto gemer. De tanto chorar inundo de noite a minha cama; de lágrimas encharco o meu leito.",
    "reference": "Salmos 6:6"
  },
  {
    "text": "Senhor meu Deus, em ti me refugio; salva-me e livra-me de todos os que me perseguem,",
    "reference": "Salmos 7:1"
  },
  {
    "text": "Deus justo, que sondas as mentes e os corações, dá fim à maldade dos ímpios e ao justo dá segurança.",
    "reference": "Salmos 7:9"
  },
  {
    "text": "Darei graças ao Senhor por sua justiça; Ao nome do Senhor Altíssimo cantarei louvores.",
    "reference": "Salmos 7:17"
  },
  {
    "text": "Senhor, Senhor nosso, como é majestoso o teu nome em toda a terra! Tu, cuja glória é cantada nos céus.",
    "reference": "Salmos 8:1"
  },
  {
    "text": "Tu o fizeste um pouco menor do que os seres celestiais e o coroaste de glória e de honra.",
    "reference": "Salmos 8:5"
  },
  {
    "text": "Senhor, quero dar-te graças de todo o coração e falar de todas as tuas maravilhas.",
    "reference": "Salmos 9:1"
  },
  {
    "text": "Cantem louvores ao Senhor, que reina em Sião; proclamem entre as nações os seus feitos.",
    "reference": "Salmos 9:11"
  },
  {
    "text": "Infunde-lhes terror, Senhor; saibam as nações que não passam de seres humanos. Pausa",
    "reference": "Salmos 9:20"
  },
  {
    "text": "Senhor, por que estás tão longe? Por que te escondes em tempos de angústia?",
    "reference": "Salmos 10:1"
  },
  {
    "text": "Agachado, fica de tocaia; as suas vítimas caem em seu poder.",
    "reference": "Salmos 10:10"
  },
  {
    "text": "Defendes o órfão e o oprimido, a fim de que o homem, que é pó, já não cause terror.",
    "reference": "Salmos 10:18"
  },
  {
    "text": "No Senhor me refugio. Como então vocês podem dizer-me: \"Fuja como um pássaro para os montes\"?",
    "reference": "Salmos 11:1"
  },
  {
    "text": "O Senhor está no seu santo templo; o Senhor tem o seu trono nos céus. Seus olhos observam; seus olhos examinam os filhos dos homens.",
    "reference": "Salmos 11:4"
  },
  {
    "text": "Salva-nos, Senhor! Já não há quem seja fiel; já não se confia em ninguém entre os homens.",
    "reference": "Salmos 12:1"
  },
  {
    "text": "Por causa da opressão do necessitado e do gemido do pobre, agora me levantarei\", diz o Senhor. \"Eu lhes darei a segurança que tanto anseiam. ",
    "reference": "Salmos 12:5"
  },
  {
    "text": "Até quando, Senhor? Para sempre te esquecerás de mim? Até quando esconderás de mim o teu rosto?",
    "reference": "Salmos 13:1"
  },
  {
    "text": "os meus inimigos dirão: \"Eu o venci\", e os meus adversários festejarão o meu fracasso.",
    "reference": "Salmos 13:4"
  },
  {
    "text": "Diz o tolo em seu coração: \"Deus não existe\". Corromperam-se e cometeram atos detestáveis; não há ninguém que faça o bem.",
    "reference": "Salmos 14:1"
  },
  {
    "text": "Será que nenhum dos malfeitores aprende? Eles devoram o meu povo como quem come pão, e não clamam pelo Senhor!",
    "reference": "Salmos 14:4"
  },
  {
    "text": "Senhor, quem habitará no teu santuário? Quem poderá morar no teu santo monte?",
    "reference": "Salmos 15:1"
  },
  {
    "text": "Protege-me, ó Deus, pois em ti me refugio.",
    "reference": "Salmos 16:1"
  },
  {
    "text": "As divisas caíram para mim em lugares agradáveis: Tenho uma bela herança!",
    "reference": "Salmos 16:6"
  },
  {
    "text": "Tu me farás conhecer a vereda da vida, a alegria plena da tua presença, eterno prazer à tua direita.",
    "reference": "Salmos 16:11"
  },
  {
    "text": "Ouve, Senhor, a minha justa queixa; atenta para o meu clamor. Dá ouvidos à minha oração, que não vem de lábios falsos.",
    "reference": "Salmos 17:1"
  },
  {
    "text": "Protege-me como à menina dos teus olhos; esconde-me à sombra das tuas asas,",
    "reference": "Salmos 17:8"
  },
  {
    "text": "Quanto a mim, feita a justiça, verei a tua face; quando despertar ficarei satisfeito ao ver a tua semelhança.",
    "reference": "Salmos 17:15"
  },
  {
    "text": "Eu te amo, ó Senhor, minha força.",
    "reference": "Salmos 18:1"
  },
  {
    "text": "ao puro te revelas puro, mas com o perverso reages à altura.",
    "reference": "Salmos 18:26"
  },
  {
    "text": "Ele dá grandes vitórias ao seu rei; é bondoso com o seu ungido, com Davi e os seus descendentes para sempre.",
    "reference": "Salmos 18:50"
  },
  {
    "text": "Os céus declaram a glória de Deus; o firmamento proclama a obra das suas mãos.",
    "reference": "Salmos 19:1"
  },
  {
    "text": "Os preceitos do Senhor são justos, e dão alegria ao coração. Os mandamentos do Senhor são límpidos, e trazem luz aos olhos.",
    "reference": "Salmos 19:8"
  },
  {
    "text": "Que as palavras da minha boca e a meditação do meu coração sejam agradáveis a ti, Senhor, minha Rocha e meu Resgatador!",
    "reference": "Salmos 19:14"
  },
  {
    "text": "Que o Senhor te responda no tempo da angústia; o nome do Deus de Jacó te proteja!",
    "reference": "Salmos 20:1"
  },
  {
    "text": "Saudaremos a tua vitória com gritos de alegria e ergueremos as nossas bandeiras em nome do nosso Deus. Que o Senhor atenda todos os teus pedidos!",
    "reference": "Salmos 20:5"
  },
  {
    "text": "Estes são os provérbios de Salomão, filho de Davi, rei de Israel.",
    "reference": "Provérbios 1:1"
  },
  {
    "text": "Assim como é inútil estender a rede se as aves o observam,",
    "reference": "Provérbios 1:17"
  },
  {
    "text": "mas quem me ouvir viverá em segurança e estará tranqüilo, sem temer nenhum mal\".",
    "reference": "Provérbios 1:33"
  },
  {
    "text": "Meu filho, se você aceitar as minhas palavras e guardar no coração os meus mandamentos;",
    "reference": "Provérbios 2:1"
  },
  {
    "text": "A sabedoria o livrará do caminho dos maus, dos homens de palavras perversas,",
    "reference": "Provérbios 2:12"
  },
  {
    "text": "mas os ímpios serão eliminados da terra, e dela os infiéis serão arrancados.",
    "reference": "Provérbios 2:22"
  },
  {
    "text": "Meu filho, não se esqueça da minha lei, mas guarde no coração os meus mandamentos,",
    "reference": "Provérbios 3:1"
  },
  {
    "text": "A sabedoria é árvore que dá vida a quem a abraça; quem a ela se apega será abençoado.",
    "reference": "Provérbios 3:18"
  },
  {
    "text": "A honra é herança dos sábios, mas o Senhor expõe os tolos ao ridículo.",
    "reference": "Provérbios 3:35"
  },
  {
    "text": "Ouçam, meus filhos, a instrução de um pai; estejam atentos, e obterão discernimento.",
    "reference": "Provérbios 4:1"
  },
  {
    "text": "Não siga pela vereda dos ímpios nem ande no caminho dos maus.",
    "reference": "Provérbios 4:14"
  },
  {
    "text": "Não se desvie nem para a direita nem para a esquerda; afaste os seus pés da maldade.",
    "reference": "Provérbios 4:27"
  },
  {
    "text": "Meu filho, dê atenção à minha sabedoria, incline os ouvidos para perceber o meu discernimento.",
    "reference": "Provérbios 5:1"
  },
  {
    "text": "Você dirá: \"Como odiei a disciplina! Como o meu coração rejeitou a repreensão!",
    "reference": "Provérbios 5:12"
  },
  {
    "text": "Certamente morrerá por falta de disciplina; andará cambaleando por causa da sua insensatez.",
    "reference": "Provérbios 5:23"
  },
  {
    "text": "Meu filho, se você serviu de fiador do seu próximo, se, com um aperto de mãos, empenhou-se por um estranho",
    "reference": "Provérbios 6:1"
  },
  {
    "text": "coração que traça planos perversos, pés que se apressam para fazer o mal,",
    "reference": "Provérbios 6:18"
  },
  {
    "text": "Não aceitará nenhuma compensação; os melhores presentes não o acalmarão.",
    "reference": "Provérbios 6:35"
  },
  {
    "text": "Meu filho, obedeça às minhas palavras e no íntimo guarde os meus mandamentos.",
    "reference": "Provérbios 7:1"
  },
  {
    "text": "Tenho em casa a carne dos sacrifícios de comunhão, que hoje fiz para cumprir os meus votos.",
    "reference": "Provérbios 7:14"
  },
  {
    "text": "A casa dela é um caminho que desce para a sepultura, para as moradas da morte.",
    "reference": "Provérbios 7:27"
  },
  {
    "text": "A sabedoria está clamando, o discernimento ergue a sua voz;",
    "reference": "Provérbios 8:1"
  },
  {
    "text": "Meu fruto é melhor do que o ouro, do que o ouro puro; o que ofereço é superior à prata escolhida.",
    "reference": "Provérbios 8:19"
  },
  {
    "text": "Mas aquele que de mim se afasta, a si mesmo se agride; todos os que me odeiam amam a morte\".",
    "reference": "Provérbios 8:36"
  },
  {
    "text": "A sabedoria construiu sua casa; ergueu suas sete colunas.",
    "reference": "Provérbios 9:1"
  },
  {
    "text": "O temor do Senhor é o princípio da sabedoria, e o conhecimento do Santo é entendimento.",
    "reference": "Provérbios 9:10"
  },
  {
    "text": "Mas eles nem imaginam que ali estão os espíritos dos mortos, que os seus convidados estão nas profundezas da sepultura.",
    "reference": "Provérbios 9:18"
  },
  {
    "text": "Provérbios de Salomão: O filho sábio dá alegria ao pai; o filho tolo dá tristeza à mãe.",
    "reference": "Provérbios 10:1"
  },
  {
    "text": "Quem acolhe a disciplina mostra o caminho da vida, mas quem ignora a repreensão desencaminha outros.",
    "reference": "Provérbios 10:17"
  },
  {
    "text": "Os lábios do justo sabem o que é próprio, mas a boca dos ímpios só conhece a perversidade.",
    "reference": "Provérbios 10:32"
  },
  {
    "text": "O Senhor repudia balanças desonestas, mas os pesos exatos lhe dão prazer.",
    "reference": "Provérbios 11:1"
  },
  {
    "text": "A mulher bondosa conquista o respeito, mas os homens cruéis só conquistam riquezas.",
    "reference": "Provérbios 11:16"
  },
  {
    "text": "Se os justos recebem a punição que merecem na terra, quanto mais o ímpio e o pecador!",
    "reference": "Provérbios 11:31"
  },
  {
    "text": "Todo o que ama a disciplina ama o conhecimento, mas aquele que odeia a repreensão é tolo.",
    "reference": "Provérbios 12:1"
  },
  {
    "text": "O caminho do insensato parece-lhe justo, mas o sábio ouve os conselhos.",
    "reference": "Provérbios 12:15"
  },
  {
    "text": "No caminho da justiça está a vida; essa é a vereda que preserva da morte.",
    "reference": "Provérbios 12:28"
  },
  {
    "text": "O filho sábio acolhe a instrução do pai, mas o zombador não ouve a repreensão.",
    "reference": "Provérbios 13:1"
  },
  {
    "text": "Quem zomba da instrução pagará por ela, mas aquele que respeita o mandamento será recompensado.",
    "reference": "Provérbios 13:13"
  },
  {
    "text": "O justo come até satisfazer o apetite, mas os ímpios permanecem famintos.",
    "reference": "Provérbios 13:25"
  },
  {
    "text": "A mulher sábia edifica a sua casa, mas com as próprias mãos a insensata derruba a sua.",
    "reference": "Provérbios 14:1"
  },
  {
    "text": "Os inexperientes herdam a insensatez, mas o conhecimento é a coroa dos prudentes.",
    "reference": "Provérbios 14:18"
  },
  {
    "text": "O servo sábio agrada o rei, mas o que procede vergonhosamente incorre em sua ira.",
    "reference": "Provérbios 14:35"
  },
  {
    "text": "A resposta calma desvia a fúria, mas a palavra ríspida desperta a ira.",
    "reference": "Provérbios 15:1"
  },
  {
    "text": "É melhor ter verduras na refeição onde há amor do que um boi gordo acompanhado de ódio.",
    "reference": "Provérbios 15:17"
  },
  {
    "text": "O temor do Senhor ensina a sabedoria, e a humildade antecede a honra.",
    "reference": "Provérbios 15:33"
  },
  {
    "text": "Ao homem pertencem os planos do coração, mas do Senhor vem a resposta da língua.",
    "reference": "Provérbios 16:1"
  },
  {
    "text": "A vereda do justo evita o mal; quem guarda o seu caminho preserva a sua vida.",
    "reference": "Provérbios 16:17"
  },
  {
    "text": "A sorte é lançada no colo, mas a decisão vem do Senhor.",
    "reference": "Provérbios 16:33"
  },
  {
    "text": "Melhor é um pedaço de pão seco com paz e tranqüilidade do que uma casa onde há banquetes, e muitas brigas.",
    "reference": "Provérbios 17:1"
  },
  {
    "text": "Absolver o ímpio e condenar o justo, são coisas que o Senhor odeia.",
    "reference": "Provérbios 17:15"
  },
  {
    "text": "Até o insensato passará por sábio, se ficar quieto, e, se contiver a língua, parecerá que tem discernimento.",
    "reference": "Provérbios 17:28"
  },
  {
    "text": "Quem se isola, busca interesses egoístas, e se rebela contra a sensatez.",
    "reference": "Provérbios 18:1"
  },
  {
    "text": "Quem responde antes de ouvir, comete insensatez e passa vergonha.",
    "reference": "Provérbios 18:13"
  },
  {
    "text": "Quem tem muitos amigos pode chegar à ruína, mas existe amigo mais apegado que um irmão.",
    "reference": "Provérbios 18:24"
  },
  {
    "text": "Melhor é o pobre que vive com integridade do que o tolo que fala perversamente.",
    "reference": "Provérbios 19:1"
  },
  {
    "text": "A preguiça leva ao sono profundo, e o preguiçoso passa fome.",
    "reference": "Provérbios 19:15"
  },
  {
    "text": "Os castigos estão preparados para os zombadores, e os açoites para as costas dos tolos.",
    "reference": "Provérbios 19:29"
  },
  {
    "text": "O vinho é zombadore a bebida fermentada provoca brigas; não é sábio deixar-se dominar por eles.",
    "reference": "Provérbios 20:1"
  },
  {
    "text": "Tome-se a veste de quem serve de fiador ao estranho; sirva ela de penhor de quem dá garantia a uma mulher leviana.",
    "reference": "Provérbios 20:16"
  },
  {
    "text": "Os golpes e os ferimentos eliminam o mal; os açoites limpam as profundezas do ser.",
    "reference": "Provérbios 20:30"
  },
  {
    "text": "Visão que Isaías, filho de Amoz, teve a respeito de Judá e Jerusalém durante os reinados de Uzias, Jotão, Acaz e Ezequias, reis de Judá.",
    "reference": "Isaías 1:1"
  },
  {
    "text": "Lavem-se! Limpem-se! Removam suas más obras para longe da minha vista! Parem de fazer o mal,",
    "reference": "Isaías 1:16"
  },
  {
    "text": "O poderoso se tornará como estopa e sua obra, como fagulha; ambos serão queimados juntos sem que ninguém apague o fogo\".",
    "reference": "Isaías 1:31"
  },
  {
    "text": "Foi isto que Isaías, filho de Amoz, viu a respeito de Judá e de Jerusalém:",
    "reference": "Isaías 2:1"
  },
  {
    "text": "O Senhor dos Exércitos tem um dia reservado para todos os orgulhosos e altivos, para tudo o que é exaltado para que eles sejam humilhados;",
    "reference": "Isaías 2:12"
  },
  {
    "text": "Parem de confiar no homem, cuja vida não passa de um sopro em suas narinas. Que valor ele tem?",
    "reference": "Isaías 2:22"
  },
  {
    "text": "Vejam! O Soberano, o Senhor dos Exércitos, logo irá retirar de Jerusalém e de Judá todo o seu sustento, tanto o suprimento de comida como o suprimento de água,",
    "reference": "Isaías 3:1"
  },
  {
    "text": "O Senhor entra em juízo contra as autoridades e contra os líderes do seu povo. \"Vocês arruinaram a vinha, e o que foi roubado dos necessitados está nas suas casas.",
    "reference": "Isaías 3:14"
  },
  {
    "text": "As portas de Sião lamentarão e prantearão por causa disso; e sem nada, ela se assentará no chão.",
    "reference": "Isaías 3:26"
  },
  {
    "text": "Naquele dia sete mulheres agarrarão um homem e dirão: \"Nós mesmas providenciaremos nossa comida e nossas roupas; apenas case-se conosco e livre-nos da vergonha de sermos solteiras! ",
    "reference": "Isaías 4:1"
  },
  {
    "text": "Quando o Senhor tiver lavado a impureza das mulheres de Sião, e tiver limpado por meio de um espírito de julgamento e de um espírito de fogo o sangue derramado em Jerusalém,",
    "reference": "Isaías 4:4"
  },
  {
    "text": "Cantarei para o meu amigo o seu cântico a respeito de sua vinha: Meu amigo tinha uma vinha na encosta de uma fértil colina.",
    "reference": "Isaías 5:1"
  },
  {
    "text": "Mas o Senhor dos Exércitos será exaltado em sua justiça; o Deus santo se mostrará santo em sua retidão.",
    "reference": "Isaías 5:16"
  },
  {
    "text": "Naquele dia rugirão sobre Judá como o rugir do mar. E, se alguém olhar para a terra de Israel, verá trevas e aflição; até a luz do dia será obscurecida pelas nuvens.",
    "reference": "Isaías 5:30"
  },
  {
    "text": "No ano em que o rei Uzias morreu, eu vi o Senhor assentado num trono alto e exaltado, e a aba de sua veste enchia o templo.",
    "reference": "Isaías 6:1"
  },
  {
    "text": "Quando Acaz, filho de Jotão, e neto de Uzias, era rei de Judá, o rei Rezim, da Síria, e Peca, filho de Remalias, rei de Israel, atacaram Jerusalém, mas não puderam vencê-la.",
    "reference": "Isaías 7:1"
  },
  {
    "text": "Disse então Isaías: \"Ouçam agora, descendentes de Davi! Não basta abusarem da paciência dos homens? Também vão abusar da paciência do meu Deus?",
    "reference": "Isaías 7:13"
  },
  {
    "text": "Não chamem conspiração tudo o que esse povo chama conspiração; não temam aquilo que eles temem, nem se apavorem.",
    "reference": "Isaías 8:12"
  },
  {
    "text": "Depois olharão para a terra e só verão aflição, trevas e temível escuridão, e serão atirados em densas trevas.",
    "reference": "Isaías 8:22"
  },
  {
    "text": "Contudo, não haverá mais escuridão para os que estavam aflitos. No passado ele humilhou a terra de Zebulom e de Naftali, mas no futuro honrará a Galiléia dos gentios, o caminho do mar, junto ao Jordão.",
    "reference": "Isaías 9:1"
  },
  {
    "text": "Mas o Senhor fortaleceu os adversários de Rezim para atacá-los e incitou contra eles os seus inimigos.",
    "reference": "Isaías 9:11"
  },
  {
    "text": "Manassés contra Efraim, Efraim contra Manassés, e juntos eles se voltarão contra Judá. Apesar disso tudo, a ira divina não se desviou; sua mão continua erguida.",
    "reference": "Isaías 9:21"
  },
  {
    "text": "Ai daqueles que fazem leis injustas, que escrevem decretos opressores,",
    "reference": "Isaías 10:1"
  },
  {
    "text": "A glória das suas florestas e dos seus campos férteis se extinguirá totalmente, como definha um enfermo.",
    "reference": "Isaías 10:18"
  },
  {
    "text": "Com um machado ele ceifará a floresta; o Líbano cairá diante do Poderoso.",
    "reference": "Isaías 10:34"
  },
  {
    "text": "Um ramo surgirá do tronco de Jessé, e das suas raízes brotará um renovo.",
    "reference": "Isaías 11:1"
  },
  {
    "text": "Ninguém fará nenhum mal, nem destruirá coisa alguma em todo o meu santo monte, pois a terra se encherá do conhecimento do Senhor como as águas cobrem o mar.",
    "reference": "Isaías 11:9"
  },
  {
    "text": "Haverá uma estrada para o remanescente do seu povo que for deixado na Assíria, como houve para Israel quando saiu do Egito.",
    "reference": "Isaías 11:16"
  },
  {
    "text": "Naquele dia você dirá: \"Eu te louvarei, Senhor! Pois estavas irado contra mim, mas a tua ira desviou-se, e tu me consolaste.",
    "reference": "Isaías 12:1"
  },
  {
    "text": "Naquele dia vocês dirão: \"Louvem ao Senhor, invoquem o seu nome; anunciem entre as nações os seus feitos, e façam-nas saber que o seu nome é exaltado.",
    "reference": "Isaías 12:4"
  },
  {
    "text": "Advertência contra a Babilônia, que Isaías, filho de Amoz, recebeu em visão:",
    "reference": "Isaías 13:1"
  },
  {
    "text": "Tornarei o homem mais escasso do que o ouro puro, mais raro do que o ouro de Ofir.",
    "reference": "Isaías 13:12"
  },
  {
    "text": "As hienas uivarão em suas fortalezas, e os chacais em seus luxuosos palácios. O tempo dela está terminando, e os seus dias não serão prolongados.",
    "reference": "Isaías 13:22"
  },
  {
    "text": "O Senhor terá compaixão de Jacó; tornará a escolher Israel e os estabelecerá em sua própria terra. Os estrangeiros se juntarão a eles e farão parte da descendência de Jacó.",
    "reference": "Isaías 14:1"
  },
  {
    "text": "e fez do mundo um deserto, conquistou cidades e não deixou que os seus prisioneiros voltassem para casa? ",
    "reference": "Isaías 14:17"
  },
  {
    "text": "Que resposta se dará aos emissários daquela nação? Esta: \"O Senhor estabeleceu Sião, e nela encontrarão refúgio os aflitos do seu povo\".",
    "reference": "Isaías 14:32"
  },
  {
    "text": "Advertência contra Moabe: Sim, na noite em que foi destruída, Ar, em Moabe, ficou arruinada! E na noite em que foi destruída, Quir, em Moabe, ficou arruinada!",
    "reference": "Isaías 15:1"
  },
  {
    "text": "O meu coração clama por causa de Moabe! Os seus fugitivos vão até Zoar, até Eglate-Selisia. Sobem pelo caminho de Luíte, caminhando e chorando. Pela estrada de Horonaim levantam clamor em face da destruição,",
    "reference": "Isaías 15:5"
  },
  {
    "text": "Enviem cordeiros como tributo ao governante da terra, desde Selá, atravessando o deserto, até o monte Sião.",
    "reference": "Isaías 16:1"
  },
  {
    "text": "As lavouras de Hesbom estão murchas, como também as videiras de Sibma. Os governantes das nações pisotearam as melhores videiras, que antes chegavam até Jazar e estendiam-se para o deserto. Seus brotos espalhavam-se e chegavam ao mar.",
    "reference": "Isaías 16:8"
  },
  {
    "text": "Mas agora o Senhor diz: \"Dentro de três anos, e nem um dia a mais, o esplendor de Moabe e toda a sua grande população serão desprezados, e os seus sobreviventes serão poucos e fracos\".",
    "reference": "Isaías 16:14"
  },
  {
    "text": "Advertência contra Damasco: \"Damasco deixará de ser cidade; e se tornará um monte de ruínas.",
    "reference": "Isaías 17:1"
  },
  {
    "text": "Não olharão para os altares, obra de suas mãos, e não darão a mínima atenção aos postes sagrados e aos altares de incenso que os seus dedos fizeram.",
    "reference": "Isaías 17:8"
  },
  {
    "text": "Ao cair da tarde, pavor repentino! Antes do amanhecer, já se foram! Esse é o destino dos que nos saqueiam, essa é a parte que caberá aos que roubam.",
    "reference": "Isaías 17:14"
  },
  {
    "text": "Ai da terra do zumbido de insetos ao longo dos rios da Etiópia,",
    "reference": "Isaías 18:1"
  },
  {
    "text": "Assim diz o Senhor: \"Do lugar onde moro ficarei olhando, quieto como o ardor do sol reluzente, como a nuvem de orvalho no calor do tempo da colheita\".",
    "reference": "Isaías 18:4"
  },
  {
    "text": "Advertência contra o Egito: Vejam! O Senhor cavalga numa nuvem veloz que vai para o Egito. Os ídolos do Egito tremem diante dele, e os corações dos egípcios se derretem no íntimo.",
    "reference": "Isaías 19:1"
  },
  {
    "text": "Tornaram-se tolos os líderes de Zoã, e os de Mênfis são enganados; os chefes dos seus clãs induziram o Egito ao erro.",
    "reference": "Isaías 19:13"
  },
  {
    "text": "O Senhor dos Exércitos os abençoará, dizendo: \"Bendito seja o Egito, meu povo, a Assíria, obra de minhas mãos, e Israel, minha herança\".",
    "reference": "Isaías 19:25"
  },
  {
    "text": "No ano em que o general enviado por Sargom, rei da Assíria, atacou Asdode e a conquistou;",
    "reference": "Isaías 20:1"
  },
  {
    "text": "assim também o rei da Assíria, para vergonha do Egito, levará nus e descalços os prisioneiros egípcios e os exilados etíopes, jovens e velhos, com as nádegas descobertas.",
    "reference": "Isaías 20:4"
  },
  {
    "text": "Registro da genealogia de Jesus Cristo, filho de Davi, filho de Abraão:",
    "reference": "Mateus 1:1"
  },
  {
    "text": "Zorobabel gerou Abiúde; Abiúde gerou Eliaquim; Eliaquim gerou Azor;",
    "reference": "Mateus 1:13"
  },
  {
    "text": "Mas não teve relações com ela enquanto ela não deu à luz um filho. E ele lhe pôs o nome de Jesus.",
    "reference": "Mateus 1:25"
  },
  {
    "text": "Depois que Jesus nasceu em Belém da Judéia, nos dias do rei Herodes, magos vindos do Oriente chegaram a Jerusalém",
    "reference": "Mateus 2:1"
  },
  {
    "text": "E, tendo sido advertidos em sonho para não voltarem a Herodes, retornaram a sua terra por outro caminho.",
    "reference": "Mateus 2:12"
  },
  {
    "text": "e foi viver numa cidade chamada Nazaré. Assim cumpriu-se o que fora dito pelos profetas: Ele será chamado Nazareno.",
    "reference": "Mateus 2:23"
  },
  {
    "text": "Naqueles dias surgiu João Batista, pregando no deserto da Judéia.",
    "reference": "Mateus 3:1"
  },
  {
    "text": "Não pensem que vocês podem dizer a si mesmos: ‘Abraão é nosso pai’. Pois eu lhes digo que destas pedras Deus pode fazer surgir filhos a Abraão.",
    "reference": "Mateus 3:9"
  },
  {
    "text": "Então Jesus foi levado pelo Espírito ao deserto, para ser tentado pelo diabo.",
    "reference": "Mateus 4:1"
  },
  {
    "text": "Saindo de Nazaré, foi viver em Cafarnaum, que ficava junto ao mar, na região de Zebulom e Naftali,",
    "reference": "Mateus 4:13"
  },
  {
    "text": "Grandes multidões o seguiam, vindas da Galiléia, Decápolis, Jerusalém, Judéia e da região do outro lado do Jordão.",
    "reference": "Mateus 4:25"
  },
  {
    "text": "Vendo as multidões, Jesus subiu ao monte e se assentou. Seus discípulos aproximaram-se dele,",
    "reference": "Mateus 5:1"
  },
  {
    "text": "Entre em acordo depressa com seu adversário que pretende levá-lo ao tribunal. Faça isso enquanto ainda estiver com ele a caminho, pois, caso contrário, ele poderá entregá-lo ao juiz, e o juiz ao guarda, e você poderá ser jogado na prisão.",
    "reference": "Mateus 5:25"
  },
  {
    "text": "Portanto, sejam perfeitos como perfeito é o Pai celestial de vocês\".",
    "reference": "Mateus 5:48"
  },
  {
    "text": "Tenham o cuidado de não praticar suas ‘obras de justiça’ diante dos outros para serem vistos por eles. Se fizerem isso, vocês não terão nenhuma recompensa do Pai celestial.",
    "reference": "Mateus 6:1"
  },
  {
    "text": "para que não pareça aos outros que você está jejuando, mas apenas a seu Pai, que vê no secreto. E seu Pai, que vê no secreto, o recompensará\".",
    "reference": "Mateus 6:18"
  },
  {
    "text": "Portanto, não se preocupem com o amanhã, pois o amanhã se preocupará consigo mesmo. Basta a cada dia o seu próprio mal\".",
    "reference": "Mateus 6:34"
  },
  {
    "text": "Não julguem, para que vocês não sejam julgados.",
    "reference": "Mateus 7:1"
  },
  {
    "text": "Cuidado com os falsos profetas. Eles vêm a vocês vestidos de peles de ovelhas, mas por dentro são lobos devoradores.",
    "reference": "Mateus 7:15"
  },
  {
    "text": "porque ele as ensinava como quem tem autoridade, e não como os mestres da lei.",
    "reference": "Mateus 7:29"
  },
  {
    "text": "Quando ele desceu do monte, grandes multidões o seguiram.",
    "reference": "Mateus 8:1"
  },
  {
    "text": "Quando Jesus viu a multidão ao seu redor, deu ordens para que atravessassem para o outro lado do mar.",
    "reference": "Mateus 8:18"
  },
  {
    "text": "Toda a cidade saiu ao encontro de Jesus, e quando o viram, suplicaram-lhe que saísse do território deles.",
    "reference": "Mateus 8:34"
  },
  {
    "text": "Entrando Jesus num barco, atravessou o mar e foi para a sua própria cidade.",
    "reference": "Mateus 9:1"
  },
  {
    "text": "Nisso uma mulher que havia doze anos vinha sofrendo de uma hemorragia, chegou por trás dele e tocou na borda do seu manto,",
    "reference": "Mateus 9:20"
  },
  {
    "text": "Peçam, pois, ao Senhor da seara que envie trabalhadores para a sua seara\".",
    "reference": "Mateus 9:38"
  },
  {
    "text": "Chamando seus doze discípulos, deu-lhes autoridade para expulsar espíritos imundos e curar todas as doenças e enfermidades.",
    "reference": "Mateus 10:1"
  },
  {
    "text": "Todos odiarão vocês por minha causa, mas aquele que perseverar até o fim será salvo.",
    "reference": "Mateus 10:22"
  },
  {
    "text": "Depois que terminou de instruir seus doze discípulos, Jesus saiu para ensinar e pregar nas cidades da Galiléia.",
    "reference": "Mateus 11:1"
  },
  {
    "text": "A que posso comparar esta geração? São como crianças que ficam sentadas nas praças e gritam umas às outras:",
    "reference": "Mateus 11:16"
  },
  {
    "text": "Pois o meu jugo é suave e o meu fardo é leve\".",
    "reference": "Mateus 11:30"
  },
  {
    "text": "Naquela ocasião Jesus passou pelas lavouras de cereal no sábado. Seus discípulos estavam com fome e começaram a colher espigas para comê-las.",
    "reference": "Mateus 12:1"
  },
  {
    "text": "Se Satanás expulsa Satanás, está dividido contra si mesmo. Como, então, subsistirá seu reino?",
    "reference": "Mateus 12:26"
  },
  {
    "text": "Pois quem faz a vontade de meu Pai que está nos céus, este é meu irmão, minha irmã e minha mãe\".",
    "reference": "Mateus 12:50"
  },
  {
    "text": "Naquele mesmo dia Jesus saiu de casa e assentou-se à beira-mar.",
    "reference": "Mateus 13:1"
  },
  {
    "text": "Deixem que cresçam juntos até à colheita. Então direi aos encarregados da colheita: Juntem primeiro o joio e amarrem-no em feixes para ser queimado; depois juntem o trigo e guardem-no no meu celeiro’ \".",
    "reference": "Mateus 13:30"
  },
  {
    "text": "Por aquele tempo Herodes, o tetrarca, ouviu os relatos a respeito de Jesus",
    "reference": "Mateus 14:1"
  },
  {
    "text": "Suplicavam-lhe que apenas pudessem tocar na borda do seu manto; e todos os que nele tocaram foram curados.",
    "reference": "Mateus 14:36"
  },
  {
    "text": "Então alguns fariseus e mestres da lei, vindos de Jerusalém, foram a Jesus e perguntaram:",
    "reference": "Mateus 15:1"
  },
  {
    "text": "Essas coisas tornam o homem ‘impuro’; mas o comer sem lavar as mãos não o torna ‘impuro’ \".",
    "reference": "Mateus 15:20"
  },
  {
    "text": "E, havendo despedido a multidão, Jesus entrou no barco e foi para a região de Magadã.",
    "reference": "Mateus 15:39"
  },
  {
    "text": "Os fariseus e os saduceus aproximaram-se de Jesus e o puseram à prova, pedindo-lhe que lhes mostrasse um sinal do céu.",
    "reference": "Mateus 16:1"
  },
  {
    "text": "Garanto-lhes que alguns dos que aqui se acham não experimentarão a morte antes de verem o Filho do homem vindo em seu Reino\".",
    "reference": "Mateus 16:28"
  },
  {
    "text": "Seis dias depois, Jesus tomou consigo Pedro, Tiago e João, irmão de Tiago, e os levou, em particular, a um alto monte.",
    "reference": "Mateus 17:1"
  },
  {
    "text": "Mas, para não escandalizá-los, vá ao mar e jogue o anzol. Tire o primeiro peixe que você pegar, abra-lhe a boca, e você encontrará uma moeda de quatro dracmas. Pegue-a e entregue-a a eles, para pagar o meu imposto e o seu\".",
    "reference": "Mateus 17:27"
  },
  {
    "text": "Naquele momento os discípulos chegaram a Jesus e perguntaram: \"Quem é o maior no Reino dos céus? ",
    "reference": "Mateus 18:1"
  },
  {
    "text": "Digo-lhes a verdade: Tudo o que vocês ligarem na terra terá sido ligado no céu, e tudo o que vocês desligarem na terra terá sido desligado no céu.",
    "reference": "Mateus 18:18"
  },
  {
    "text": "Assim também lhes fará meu Pai celestial, se cada um de vocês não perdoar de coração a seu irmão\".",
    "reference": "Mateus 18:35"
  },
  {
    "text": "Tendo acabado de dizer essas coisas, Jesus saiu da Galiléia e foi para a região da Judéia, no outro lado do Jordão.",
    "reference": "Mateus 19:1"
  },
  {
    "text": "Eis que alguém se aproximou de Jesus e lhe perguntou: \"Mestre, que farei de bom para ter a vida eterna? ",
    "reference": "Mateus 19:16"
  },
  {
    "text": "Contudo, muitos primeiros serão últimos, e muitos últimos serão primeiros\".",
    "reference": "Mateus 19:30"
  },
  {
    "text": "Pois o Reino dos céus é como um proprietário que saiu de manhã cedo para contratar trabalhadores para a sua vinha.",
    "reference": "Mateus 20:1"
  },
  {
    "text": "Estamos subindo para Jerusalém, e o Filho do homem será entregue aos chefes dos sacerdotes e aos mestres da lei. Eles o condenarão à morte",
    "reference": "Mateus 20:18"
  },
  {
    "text": "Jesus teve compaixão deles e tocou nos olhos deles. Imediatamente eles recuperaram a visão e o seguiram.",
    "reference": "Mateus 20:34"
  },
  {
    "text": "No princípio era aquele que é a Palavra. Ele estava com Deus, e era Deus.",
    "reference": "João 1:1"
  },
  {
    "text": "Respondeu João: \"Eu batizo com água, mas entre vocês está alguém que vocês não conhecem.",
    "reference": "João 1:26"
  },
  {
    "text": "No terceiro dia houve um casamento em Caná da Galiléia. A mãe de Jesus estava ali;",
    "reference": "João 2:1"
  },
  {
    "text": "Quando já estava chegando a Páscoa judaica, Jesus subiu a Jerusalém.",
    "reference": "João 2:13"
  },
  {
    "text": "Não precisava que ninguém lhe desse testemunho a respeito do homem, pois ele bem sabia o que havia no homem.",
    "reference": "João 2:25"
  },
  {
    "text": "Havia um fariseu chamado Nicodemos, uma autoridade entre os judeus.",
    "reference": "João 3:1"
  },
  {
    "text": "Este é o julgamento: a luz veio ao mundo, mas os homens amaram as trevas, e não a luz, porque as suas obras eram más.",
    "reference": "João 3:19"
  },
  {
    "text": "Quem crê no Filho tem a vida eterna; já quem rejeita o Filho não verá a vida, mas a ira de Deus permanece sobre ele\".",
    "reference": "João 3:36"
  },
  {
    "text": "Os fariseus ouviram falar que Jesus estava fazendo e batizando mais discípulos do que João,",
    "reference": "João 4:1"
  },
  {
    "text": "Então, deixando o seu cântaro, a mulher voltou à cidade e disse ao povo:",
    "reference": "João 4:28"
  },
  {
    "text": "Esse foi o segundo sinal miraculoso que Jesus realizou, depois que veio da Judéia para a Galiléia.",
    "reference": "João 4:54"
  },
  {
    "text": "Algum tempo depois, Jesus subiu a Jerusalém para uma festa dos judeus.",
    "reference": "João 5:1"
  },
  {
    "text": "Eu lhes asseguro: Quem ouve a minha palavra e crê naquele que me enviou, tem a vida eterna e não será condenado, mas já passou da morte para a vida.",
    "reference": "João 5:24"
  },
  {
    "text": "Visto, porém, que não crêem no que ele escreveu, como crerão no que eu digo? ",
    "reference": "João 5:47"
  },
  {
    "text": "Algum tempo depois Jesus partiu para a outra margem do mar da Galiléia ( ou seja, do mar de Tiberíades ),",
    "reference": "João 6:1"
  },
  {
    "text": "Mas, como eu lhes disse, vocês me viram, mas ainda não crêem.",
    "reference": "João 6:36"
  },
  {
    "text": "( Ele se referia a Judas, filho de Simão Iscariotes, que, embora fosse um dos Doze, mais tarde haveria de traí-lo. )",
    "reference": "João 6:71"
  },
  {
    "text": "Depois disso Jesus percorreu a Galiléia, mantendo-se deliberadamente longe da Judéia, porque ali os judeus procuravam tirar-lhe a vida.",
    "reference": "João 7:1"
  },
  {
    "text": "Mas nós sabemos de onde é este homem; quando o Cristo vier, ninguém saberá de onde ele é\".",
    "reference": "João 7:27"
  },
  {
    "text": "Então cada um foi para a sua casa.",
    "reference": "João 7:53"
  },
  {
    "text": "Jesus, porém, foi para o monte das Oliveiras.",
    "reference": "João 8:1"
  },
  {
    "text": "Tendo dito essas coisas, muitos creram nele.",
    "reference": "João 8:30"
  },
  {
    "text": "Então eles apanharam pedras para apedrejá-lo, mas Jesus escondeu-se e saiu do templo.",
    "reference": "João 8:59"
  },
  {
    "text": "Ao passar, Jesus viu um cego de nascença.",
    "reference": "João 9:1"
  },
  {
    "text": "Mas não sabemos como ele pode ver agora ou quem lhe abriu os olhos. Perguntem a ele. Idade ele tem; falará por si mesmo\".",
    "reference": "João 9:21"
  },
  {
    "text": "Disse Jesus: \"Se vocês fossem cegos, não seriam culpados de pecado; mas agora que dizem que podem ver, a culpa de vocês permanece\".",
    "reference": "João 9:41"
  },
  {
    "text": "Eu lhes asseguro que aquele que não entra no aprisco das ovelhas pela porta, mas sobe por outro lugar, é ladrão e assaltante.",
    "reference": "João 10:1"
  },
  {
    "text": "Celebrava-se a festa da Dedicação, em Jerusalém. Era inverno,",
    "reference": "João 10:22"
  },
  {
    "text": "Havia um homem chamado Lázaro. Ele era de Betânia, do povoado de Maria e de sua irmã Marta. E aconteceu que Lázaro ficou doente.",
    "reference": "João 11:1"
  },
  {
    "text": "Ao ouvir isso, Maria levantou-se depressa e foi ao encontro dele.",
    "reference": "João 11:29"
  },
  {
    "text": "Mas os chefes dos sacerdotes e os fariseus tinham ordenado que, se alguém soubesse onde Jesus estava, o denunciasse, para que o pudessem prender.",
    "reference": "João 11:57"
  },
  {
    "text": "Seis dias antes da Páscoa Jesus chegou a Betânia, onde vivia Lázaro, a quem ressuscitara dos mortos.",
    "reference": "João 12:1"
  },
  {
    "text": "Quem me serve precisa seguir-me; e, onde estou, o meu servo também estará. Aquele que me serve, meu Pai o honrará.",
    "reference": "João 12:26"
  },
  {
    "text": "Sei que o seu mandamento é a vida eterna. Portanto, o que eu digo é exatamente o que o Pai me mandou dizer\".",
    "reference": "João 12:50"
  },
  {
    "text": "Um pouco antes da festa da Páscoa, sabendo Jesus que havia chegado o tempo em que deixaria este mundo e iria para o Pai, tendo amado os seus que estavam no mundo, amou-os até o fim.",
    "reference": "João 13:1"
  },
  {
    "text": "Eu lhes garanto: Quem receber aquele que eu enviar, estará me recebendo; e quem me recebe, recebe aquele que me enviou\".",
    "reference": "João 13:20"
  },
  {
    "text": "Então Jesus respondeu: \"Você dará a vida por mim? Asseguro-lhe que, antes que o galo cante, você me negará três vezes! ",
    "reference": "João 13:38"
  },
  {
    "text": "Não se perturbe o coração de vocês. Creiam em Deus; creiam também em mim.",
    "reference": "João 14:1"
  },
  {
    "text": "Todavia para que o mundo saiba que amo o Pai e que faço o que meu Pai me ordenou. Levantem-se, vamo-nos daqui! ",
    "reference": "João 14:31"
  },
  {
    "text": "Eu sou a videira verdadeira, e meu Pai é o agricultor.",
    "reference": "João 15:1"
  },
  {
    "text": "Vocês serão meus amigos, se fizerem o que eu lhes ordeno.",
    "reference": "João 15:14"
  },
  {
    "text": "Tenho-lhes dito tudo isso para que vocês não venham a tropeçar.",
    "reference": "João 16:1"
  },
  {
    "text": "Alguns dos seus discípulos disseram uns aos outros: \"O que ele quer dizer com isso: ‘Mais um pouco e não me verão’; e ‘um pouco mais e me verão de novo’, e ‘Porque vou para o Pai’? ",
    "reference": "João 16:17"
  },
  {
    "text": "Eu lhes disse essas coisas para que em mim vocês tenham paz. Neste mundo vocês terão aflições; contudo, tenham ânimo! Eu venci o mundo\".",
    "reference": "João 16:33"
  },
  {
    "text": "Depois de dizer isso, Jesus olhou para o céu e orou: \"Pai, chegou a hora. Glorifica o teu Filho, para que o teu Filho te glorifique.",
    "reference": "João 17:1"
  },
  {
    "text": "Dei-lhes a tua palavra, e o mundo os odiou, pois eles não são do mundo, como eu também não sou.",
    "reference": "João 17:14"
  },
  {
    "text": "Eu os fiz conhecer o teu nome, e continuarei a fazê-lo, a fim de que o amor que tens por mim esteja neles, e eu neles esteja\".",
    "reference": "João 17:26"
  },
  {
    "text": "Tendo terminado de orar, Jesus saiu com os seus discípulos e atravessou o vale do Cedrom. Do outro lado havia um olival, onde entrou com eles.",
    "reference": "João 18:1"
  },
  {
    "text": "Por que me interrogas? Pergunta aos que me ouviram. Certamente eles sabem o que eu disse\".",
    "reference": "João 18:21"
  },
  {
    "text": "Eles, em resposta, gritaram: \"Não, ele não! Queremos Barrabás! \" Ora, Barrabás era um bandido.",
    "reference": "João 18:40"
  },
  {
    "text": "Então Pilatos mandou açoitar Jesus.",
    "reference": "João 19:1"
  },
  {
    "text": "Pilatos respondeu: \"O que escrevi, escrevi\".",
    "reference": "João 19:22"
  },
  {
    "text": "Por ser o Dia da Preparação para os judeus e visto que o sepulcro ficava perto, colocaram Jesus ali.",
    "reference": "João 19:42"
  },
  {
    "text": "No primeiro dia da semana, bem cedo, estando ainda escuro, Maria Madalena chegou ao sepulcro e viu que a pedra da entrada tinha sido removida.",
    "reference": "João 20:1"
  },
  {
    "text": "Mas estes foram escritos para que vocês creiam que Jesus é o Cristo, o Filho de Deus e, crendo, tenham vida em seu nome.",
    "reference": "João 20:31"
  },
  {
    "text": "Paulo, servo de Cristo Jesus, chamado para ser apóstolo, separado para o evangelho de Deus,",
    "reference": "Romanos 1:1"
  },
  {
    "text": "Porque no evangelho é revelada a justiça de Deus, uma justiça que do princípio ao fim é pela fé, como está escrito: \"O justo viverá pela fé\".",
    "reference": "Romanos 1:17"
  },
  {
    "text": "Embora conheçam o justo decreto de Deus, de que as pessoas que praticam tais coisas merecem a morte, não somente continuam a praticá-las, mas também aprovam aqueles que as praticam.",
    "reference": "Romanos 1:32"
  },
  {
    "text": "Portanto, você, que julga, os outros é indesculpável; pois está condenando a si mesmo naquilo em que julga, visto que você, que julga, pratica as mesmas coisas.",
    "reference": "Romanos 2:1"
  },
  {
    "text": "pois mostram que as exigências da lei estão gravadas em seus corações. Disso dão testemunho também a consciência e os pensamentos deles, ora acusando-os, ora defendendo-os. )",
    "reference": "Romanos 2:15"
  },
  {
    "text": "Não! Judeu é quem o é interiormente, e circuncisão é a operada no coração, pelo Espírito, e não pela lei escrita. Para estes o louvor não provém dos homens, mas de Deus.",
    "reference": "Romanos 2:29"
  },
  {
    "text": "Que vantagem há então em ser judeu, ou que utilidade há na circuncisão?",
    "reference": "Romanos 3:1"
  },
  {
    "text": "ruína e desgraça marcam os seus caminhos,",
    "reference": "Romanos 3:16"
  },
  {
    "text": "Anulamos então a lei pela fé? De maneira nenhuma! Pelo contrário, confirmamos a lei.",
    "reference": "Romanos 3:31"
  },
  {
    "text": "Portanto, que diremos do nosso antepassado Abraão?",
    "reference": "Romanos 4:1"
  },
  {
    "text": "Não foi mediante a lei que Abraão e a sua descendência receberam a promessa de que ele seria o herdeiro do mundo, mas mediante a justiça que vem da fé.",
    "reference": "Romanos 4:13"
  },
  {
    "text": "Ele foi entregue à morte por nossos pecados e ressuscitado para nossa justificação.",
    "reference": "Romanos 4:25"
  },
  {
    "text": "Tendo sido, pois, justificados pela fé, temos paz com Deus, por nosso Senhor Jesus Cristo,",
    "reference": "Romanos 5:1"
  },
  {
    "text": "Não apenas isso, mas também nos gloriamos em Deus, por meio de nosso Senhor Jesus Cristo, mediante quem recebemos agora a reconciliação.",
    "reference": "Romanos 5:11"
  },
  {
    "text": "a fim de que, assim como o pecado reinou na morte, também a graça reine pela justiça para conceder vida eterna, mediante Jesus Cristo, nosso Senhor.",
    "reference": "Romanos 5:21"
  },
  {
    "text": "Que diremos então? Continuaremos pecando para que a graça aumente?",
    "reference": "Romanos 6:1"
  },
  {
    "text": "Portanto, não permitam que o pecado continue dominando os seus corpos mortais, fazendo que vocês obedeçam aos seus desejos.",
    "reference": "Romanos 6:12"
  },
  {
    "text": "Pois o salário do pecado é a morte, mas o dom gratuito de Deus é a vida eterna em Cristo Jesus, nosso Senhor.",
    "reference": "Romanos 6:23"
  },
  {
    "text": "Meus irmãos, falo a vocês como a pessoas que conhecem a lei. Acaso vocês não sabem que a lei tem autoridade sobre alguém apenas enquanto ele vive?",
    "reference": "Romanos 7:1"
  },
  {
    "text": "Graças a Deus por Jesus Cristo, nosso Senhor! De modo que, com a mente, eu próprio sou escravo da lei de Deus; mas, com a carne, da lei do pecado.",
    "reference": "Romanos 7:25"
  },
  {
    "text": "Portanto, agora já não há condenação para os que estão em Cristo Jesus,",
    "reference": "Romanos 8:1"
  },
  {
    "text": "Pois ela foi submetida à futilidade, não pela sua própria escolha, mas por causa da vontade daquele que a sujeitou, na esperança",
    "reference": "Romanos 8:20"
  },
  {
    "text": "nem altura nem profundidade, nem qualquer outra coisa na criação será capaz de nos separar do amor de Deus que está em Cristo Jesus, nosso Senhor.",
    "reference": "Romanos 8:39"
  },
  {
    "text": "Digo a verdade em Cristo, não minto; minha consciência o confirma no Espírito Santo:",
    "reference": "Romanos 9:1"
  },
  {
    "text": "Pois a Escritura diz ao faraó: \"Eu o levantei exatamente com este propósito: mostrar em você o meu poder, e para que o meu nome seja proclamado em toda a terra\".",
    "reference": "Romanos 9:17"
  },
  {
    "text": "Como está escrito: \"Eis que ponho em Sião uma pedra de tropeço e uma rocha que faz cair; e aquele que nela confia jamais será envergonhado\".",
    "reference": "Romanos 9:33"
  },
  {
    "text": "Irmãos, o desejo do meu coração e a minha oração a Deus pelos israelitas é que eles sejam salvos.",
    "reference": "Romanos 10:1"
  },
  {
    "text": "Como diz a Escritura: \"Todo o que nele confia jamais será envergonhado\".",
    "reference": "Romanos 10:11"
  },
  {
    "text": "Mas a respeito de Israel, ele diz: \"O tempo todo estendi as mãos a um povo desobediente e rebelde\".",
    "reference": "Romanos 10:21"
  },
  {
    "text": "Pergunto, pois: Acaso Deus rejeitou o seu povo? De maneira nenhuma! Eu mesmo sou israelita, descendente de Abraão, da tribo de Benjamim.",
    "reference": "Romanos 11:1"
  },
  {
    "text": "Então você dirá: \"Os ramos foram cortados, para que eu fosse enxertado\".",
    "reference": "Romanos 11:19"
  },
  {
    "text": "Pois dele, por ele e para ele são todas as coisas. A ele seja a glória para sempre! Amém.",
    "reference": "Romanos 11:36"
  },
  {
    "text": "Portanto, irmãos, rogo-lhes pelas misericórdias de Deus que se ofereçam em sacrifício vivo, santo e agradável a Deus; este é o culto racional de vocês.",
    "reference": "Romanos 12:1"
  },
  {
    "text": "Nunca lhes falte o zelo, sejam fervorosos no espírito, sirvam ao Senhor.",
    "reference": "Romanos 12:11"
  },
  {
    "text": "Não se deixem vencer pelo mal, mas vençam o mal com o bem.",
    "reference": "Romanos 12:21"
  },
  {
    "text": "Todos devem sujeitar-se às autoridades governamentais, pois não há autoridade que não venha de Deus; as autoridades que existem foram por ele estabelecidas.",
    "reference": "Romanos 13:1"
  },
  {
    "text": "Não devam nada a ninguém, a não ser o amor de uns pelos outros, pois aquele que ama seu próximo tem cumprido a lei.",
    "reference": "Romanos 13:8"
  },
  {
    "text": "Pelo contrário, revistam-se do Senhor Jesus Cristo, e não fiquem premeditando como satisfazer os desejos da carne.",
    "reference": "Romanos 13:14"
  },
  {
    "text": "Aceitem o que é fraco na fé, sem discutir assuntos controvertidos.",
    "reference": "Romanos 14:1"
  },
  {
    "text": "Assim, cada um de nós prestará contas de si mesmo a Deus.",
    "reference": "Romanos 14:12"
  },
  {
    "text": "Mas aquele que tem dúvida é condenado se comer, porque não come com fé; e tudo o que não provém da fé é pecado.",
    "reference": "Romanos 14:23"
  },
  {
    "text": "Nós, que somos fortes, devemos suportar as fraquezas dos fracos, e não agradar a nós mesmos.",
    "reference": "Romanos 15:1"
  },
  {
    "text": "Portanto, eu me glorio em Cristo Jesus, em meu serviço a Deus.",
    "reference": "Romanos 15:17"
  },
  {
    "text": "O Deus da paz seja com todos vocês. Amém.",
    "reference": "Romanos 15:33"
  },
  {
    "text": "Recomendo-lhes nossa irmã Febe, serva da igreja em Cencréia.",
    "reference": "Romanos 16:1"
  },
  {
    "text": "Saúdem Asíncrito, Flegonte, Hermes, Pátrobas, Hermas e os irmãos que estão com eles.",
    "reference": "Romanos 16:14"
  },
  {
    "text": "ao único Deus sábio seja dada glória para todo o sempre, por meio de Jesus Cristo. Amém.",
    "reference": "Romanos 16:27"
  },
  {
    "text": "Paulo, apóstolo enviado, não da parte de homens nem por meio de pessoa alguma, mas por Jesus Cristo e por Deus Pai, que o ressuscitou dos mortos,",
    "reference": "Gálatas 1:1"
  },
  {
    "text": "Vocês ouviram qual foi o meu procedimento no judaísmo, como perseguia com violência a igreja de Deus, procurando destruí-la.",
    "reference": "Gálatas 1:13"
  },
  {
    "text": "Catorze anos depois, subi novamente a Jerusalém, dessa vez com Barnabé, levando também Tito comigo.",
    "reference": "Gálatas 2:1"
  },
  {
    "text": "Quando, porém, Pedro veio a Antioquia, enfrentei-o face a face, por sua atitude condenável.",
    "reference": "Gálatas 2:11"
  },
  {
    "text": "Não anulo a graça de Deus; pois, se a justiça vem pela lei, Cristo morreu inutilmente! ",
    "reference": "Gálatas 2:21"
  },
  {
    "text": "Ó gálatas insensatos! Quem os enfeitiçou? Não foi diante dos seus olhos que Jesus Cristo foi exposto como crucificado?",
    "reference": "Gálatas 3:1"
  },
  {
    "text": "Irmãos, humanamente falando, ninguém pode anular um testamento depois de ratificado, nem acrescentar-lhe algo.",
    "reference": "Gálatas 3:15"
  },
  {
    "text": "E, se vocês são de Cristo, são descendência de Abraão e herdeiros segundo a promessa.",
    "reference": "Gálatas 3:29"
  },
  {
    "text": "Digo porém que, enquanto o herdeiro é menor de idade, em nada difere de um escravo, embora seja dono de tudo.",
    "reference": "Gálatas 4:1"
  },
  {
    "text": "Tornei-me inimigo de vocês por lhes dizer a verdade?",
    "reference": "Gálatas 4:16"
  },
  {
    "text": "Portanto, irmãos, não somos filhos da escrava, mas da livre.",
    "reference": "Gálatas 4:31"
  },
  {
    "text": "Foi para a liberdade que Cristo nos libertou. Portanto, permaneçam firmes e não se deixem submeter novamente a um jugo de escravidão.",
    "reference": "Gálatas 5:1"
  },
  {
    "text": "Toda a lei se resume num só mandamento: \"Ame o seu próximo como a si mesmo\".",
    "reference": "Gálatas 5:14"
  },
  {
    "text": "Não sejamos presunçosos, provocando uns aos outros e tendo inveja uns dos outros.",
    "reference": "Gálatas 5:26"
  },
  {
    "text": "Irmãos, se alguém for surpreendido em algum pecado, vocês, que são espirituais deverão restaurá-lo com mansidão. Cuide-se, porém, cada um para que também não seja tentado.",
    "reference": "Gálatas 6:1"
  },
  {
    "text": "Portanto, enquanto temos oportunidade, façamos o bem a todos, especialmente aos da família da fé.",
    "reference": "Gálatas 6:10"
  },
  {
    "text": "Irmãos, que a graça de nosso Senhor Jesus Cristo seja com o espírito de vocês. Amém.",
    "reference": "Gálatas 6:18"
  },
  {
    "text": "Paulo, apóstolo de Cristo Jesus pela vontade de Deus, aos santos e fiéis em Cristo Jesus que estão em Éfeso:",
    "reference": "Efésios 1:1"
  },
  {
    "text": "a fim de que nós, os que primeiro esperamos em Cristo, sejamos para o louvor da sua glória.",
    "reference": "Efésios 1:12"
  },
  {
    "text": "que é o seu corpo, a plenitude daquele que enche todas as coisas, em toda e qualquer circunstância.",
    "reference": "Efésios 1:23"
  },
  {
    "text": "Vocês estavam mortos em suas transgressões e pecados,",
    "reference": "Efésios 2:1"
  },
  {
    "text": "naquela época vocês estavam sem Cristo, separados da comunidade de Israel, sendo estrangeiros quanto às alianças da promessa, sem esperança e sem Deus no mundo.",
    "reference": "Efésios 2:12"
  },
  {
    "text": "Nele vocês também estão sendo juntamente edificados, para se tornarem morada de Deus por seu Espírito.",
    "reference": "Efésios 2:22"
  },
  {
    "text": "Por essa razão, eu, Paulo, prisioneiro de Cristo Jesus por amor de vocês, gentios —",
    "reference": "Efésios 3:1"
  },
  {
    "text": "de acordo com o seu eterno plano que ele realizou em Cristo Jesus, nosso Senhor,",
    "reference": "Efésios 3:11"
  },
  {
    "text": "a ele seja a glória na igreja e em Cristo Jesus, por todas as gerações, para todo o sempre! Amém!",
    "reference": "Efésios 3:21"
  },
  {
    "text": "Como prisioneiro no Senhor, rogo-lhes que vivam de maneira digna da vocação que receberam.",
    "reference": "Efésios 4:1"
  },
  {
    "text": "Assim, eu lhes digo, e no Senhor insisto, que não vivam mais como os gentios, que vivem na futilidade dos seus pensamentos.",
    "reference": "Efésios 4:17"
  },
  {
    "text": "Sejam bondosos e compassivos uns para com os outros, perdoando-se mutuamente, assim como Deus perdoou vocês em Cristo.",
    "reference": "Efésios 4:32"
  },
  {
    "text": "Portanto, sejam imitadores de Deus, como filhos amados,",
    "reference": "Efésios 5:1"
  },
  {
    "text": "Portanto, não sejam insensatos, mas procurem compreender qual é a vontade do Senhor.",
    "reference": "Efésios 5:17"
  },
  {
    "text": "Portanto, cada um de vocês também ame a sua mulher como a si mesmo, e a mulher trate o marido com todo o respeito.",
    "reference": "Efésios 5:33"
  },
  {
    "text": "Filhos, obedeçam a seus pais no Senhor, pois isso é justo.",
    "reference": "Efésios 6:1"
  },
  {
    "text": "Por isso, vistam toda a armadura de Deus, para que possam resistir no dia mau e permanecer inabaláveis, depois de terem feito tudo.",
    "reference": "Efésios 6:13"
  },
  {
    "text": "A graça seja com todos os que amam a nosso Senhor Jesus Cristo com amor incorruptível.",
    "reference": "Efésios 6:24"
  },
  {
    "text": "Paulo e Timóteo, servos de Cristo Jesus, a todos os santos em Cristo Jesus que estão em Filipos, juntamente com os bispos e diáconos:",
    "reference": "Filipenses 1:1"
  },
  {
    "text": "Estes o fazem por amor, sabendo que aqui me encontro para a defesa do evangelho.",
    "reference": "Filipenses 1:16"
  },
  {
    "text": "já que estão passando pelo mesmo combate que me viram enfrentar e agora ouvem que ainda enfrento.",
    "reference": "Filipenses 1:30"
  },
  {
    "text": "Se por estarmos em Cristo, nós temos alguma motivação, alguma exortação de amor, alguma comunhão no Espírito, alguma profunda afeição e compaixão,",
    "reference": "Filipenses 2:1"
  },
  {
    "text": "retendo firmemente a palavra da vida. Assim, no dia de Cristo eu me orgulharei de não ter corrido nem me esforçado inutilmente.",
    "reference": "Filipenses 2:16"
  },
  {
    "text": "porque ele quase morreu por amor à causa de Cristo, arriscando a vida para suprir a ajuda que vocês não me podiam dar.",
    "reference": "Filipenses 2:30"
  },
  {
    "text": "Finalmente, meus irmãos, alegrem-se no Senhor! Escrever-lhes de novo as mesmas coisas não é cansativo para mim e é uma segurança para vocês.",
    "reference": "Filipenses 3:1"
  },
  {
    "text": "para, de alguma forma, alcançar a ressurreição dentre os mortos.",
    "reference": "Filipenses 3:11"
  },
  {
    "text": "Pelo poder que o capacita a colocar todas as coisas debaixo do seu domínio, ele transformará os nossos corpos humilhados, para serem semelhantes ao seu corpo glorioso.",
    "reference": "Filipenses 3:21"
  },
  {
    "text": "Portanto, meus irmãos, a quem amo e de quem tenho saudade, vocês que são a minha alegria e a minha coroa, permaneçam assim firmes no Senhor, ó amados!",
    "reference": "Filipenses 4:1"
  },
  {
    "text": "Sei o que é passar necessidade e sei o que é ter fartura. Aprendi o segredo de viver contente em toda e qualquer situação, seja bem alimentado, seja com fome, tendo muito, ou passando necessidade.",
    "reference": "Filipenses 4:12"
  },
  {
    "text": "A graça do Senhor Jesus Cristo seja com o espírito de vocês. Amém.",
    "reference": "Filipenses 4:23"
  },
  {
    "text": "Paulo, apóstolo de Cristo Jesus pela vontade de Deus, e o irmão Timóteo,",
    "reference": "Colossenses 1:1"
  },
  {
    "text": "Ele é a imagem do Deus invisível, o primogênito de toda a criação,",
    "reference": "Colossenses 1:15"
  },
  {
    "text": "Para isso eu me esforço, lutando conforme a sua força, que atua poderosamente em mim.",
    "reference": "Colossenses 1:29"
  },
  {
    "text": "Quero que vocês saibam quanto estou lutando por vocês, pelos que estão em Laodicéia e por todos os que ainda não me conhecem pessoalmente.",
    "reference": "Colossenses 2:1"
  },
  {
    "text": "Isso aconteceu quando vocês foram sepultados com ele no batismo, e com ele foram ressuscitados mediante a fé no poder de Deus que o ressuscitou dentre os mortos.",
    "reference": "Colossenses 2:12"
  },
  {
    "text": "Essas regras têm, de fato, aparência de sabedoria, com sua pretensa religiosidade, falsa humildade e severidade com o corpo, mas não têm valor algum para refrear os impulsos da carne.",
    "reference": "Colossenses 2:23"
  },
  {
    "text": "Portanto, já que vocês ressuscitaram com Cristo, procurem as coisas que são do alto, onde Cristo está assentado à direita de Deus.",
    "reference": "Colossenses 3:1"
  },
  {
    "text": "Suportem-se uns aos outros e perdoem as queixas que tiverem uns contra os outros. Perdoem como o Senhor lhes perdoou.",
    "reference": "Colossenses 3:13"
  },
  {
    "text": "Quem cometer injustiça receberá de volta injustiça, e não haverá exceção para ninguém.",
    "reference": "Colossenses 3:25"
  },
  {
    "text": "Senhores, dêem aos seus escravos o que é justo e direito, sabendo que vocês também têm um Senhor no céu.",
    "reference": "Colossenses 4:1"
  },
  {
    "text": "Aristarco, meu companheiro de prisão, envia-lhes saudações, bem como Marcos, primo de Barnabé. Vocês receberam instruções a respeito de Marcos, e se ele for visitá-los, recebam-no.",
    "reference": "Colossenses 4:10"
  },
  {
    "text": "Eu, Paulo, escrevo esta saudação de próprio punho. Lembrem-se das minhas algemas. A graça seja com vocês.",
    "reference": "Colossenses 4:18"
  },
  {
    "text": "Paulo, Silvano e Timóteo, à igreja dos tessalonicenses, em Deus Pai e no Senhor Jesus Cristo: A vocês, graça e paz da parte de Deus e de nosso Senhor Jesus Cristo.",
    "reference": "1 Tessalonicenses 1:1"
  },
  {
    "text": "De fato, vocês se tornaram nossos imitadores e do Senhor; apesar de muito sofrimento, receberam a palavra com alegria que vem do Espírito Santo.",
    "reference": "1 Tessalonicenses 1:6"
  },
  {
    "text": "Irmãos, vocês mesmos sabem que a visita que lhes fizemos não foi inútil.",
    "reference": "1 Tessalonicenses 2:1"
  },
  {
    "text": "Pois vocês sabem que tratamos cada um como um pai trata seus filhos,",
    "reference": "1 Tessalonicenses 2:11"
  },
  {
    "text": "De fato, vocês são a nossa glória e a nossa alegria.",
    "reference": "1 Tessalonicenses 2:20"
  },
  {
    "text": "Por isso, quando não pudemos mais suportar, achamos por bem permanecer sozinhos em Atenas",
    "reference": "1 Tessalonicenses 3:1"
  },
  {
    "text": "Por isso, irmãos, em toda a nossa necessidade e tribulação temos bom ânimo a seu respeito, por sabermos da sua fé;",
    "reference": "1 Tessalonicenses 3:7"
  },
  {
    "text": "Que ele fortaleça os seus corações para serem irrepreensíveis em santidade diante de nosso Deus e Pai, na vinda de nosso Senhor Jesus com todos os seus santos.",
    "reference": "1 Tessalonicenses 3:13"
  },
  {
    "text": "Quanto ao mais, irmãos, já os instruímos acerca de como viver a fim de agradar a Deus e, de fato, assim vocês estão procedendo. Agora lhes pedimos e exortamos no Senhor Jesus que cresçam nisso cada vez mais.",
    "reference": "1 Tessalonicenses 4:1"
  },
  {
    "text": "E, de fato, vocês amam a todos os irmãos em toda a Macedônia. Contudo, irmãos, insistimos com vocês que cada vez mais assim procedam.",
    "reference": "1 Tessalonicenses 4:10"
  },
  {
    "text": "Consolem-se uns aos outros com estas palavras.",
    "reference": "1 Tessalonicenses 4:18"
  },
  {
    "text": "Irmãos, quanto aos tempos e épocas, não precisamos escrever-lhes,",
    "reference": "1 Tessalonicenses 5:1"
  },
  {
    "text": "Tenham cuidado para que ninguém retribua o mal com o mal, mas sejam sempre bondosos uns para com os outros e para com todos.",
    "reference": "1 Tessalonicenses 5:15"
  },
  {
    "text": "A graça de nosso Senhor Jesus Cristo seja com vocês.",
    "reference": "1 Tessalonicenses 5:28"
  },
  {
    "text": "Paulo, apóstolo de Cristo Jesus pela vontade de Deus, segundo a promessa da vida que está em Cristo Jesus,",
    "reference": "2 Timóteo 1:1"
  },
  {
    "text": "sendo agora revelada pela manifestação de nosso Salvador, Cristo Jesus. Ele tornou inoperante a morte e trouxe à luz a vida e a imortalidade por meio do evangelho.",
    "reference": "2 Timóteo 1:10"
  },
  {
    "text": "Conceda-lhe o Senhor que, naquele dia, encontre misericórdia da parte do Senhor! Você sabe muito bem quantos serviços ele me prestou em Éfeso.",
    "reference": "2 Timóteo 1:18"
  },
  {
    "text": "Portanto, você, meu filho, fortifique-se na graça que há em Cristo Jesus.",
    "reference": "2 Timóteo 2:1"
  },
  {
    "text": "Continue a lembrar essas coisas a todos, advertindo-os solenemente diante de Deus, para que não se envolvam em discussões acerca de palavras; isso não tem proveito, e serve apenas para perverter os ouvintes.",
    "reference": "2 Timóteo 2:14"
  },
  {
    "text": "para que assim voltem à sobriedade e escapem da armadilha do diabo, que os aprisionou para fazerem a sua vontade.",
    "reference": "2 Timóteo 2:26"
  },
  {
    "text": "Saiba disto: nos últimos dias sobrevirão tempos terríveis.",
    "reference": "2 Timóteo 3:1"
  },
  {
    "text": "Não irão longe, porém; como no caso daqueles, a sua insensatez se tornará evidente a todos.",
    "reference": "2 Timóteo 3:9"
  },
  {
    "text": "para que o homem de Deus seja apto e plenamente preparado para toda boa obra.",
    "reference": "2 Timóteo 3:17"
  },
  {
    "text": "Na presença de Deus e de Cristo Jesus, que há de julgar os vivos e os mortos por sua manifestação e por seu Reino, eu o exorto solenemente:",
    "reference": "2 Timóteo 4:1"
  },
  {
    "text": "O Senhor seja com o seu espírito. A graça seja com vocês.",
    "reference": "2 Timóteo 4:22"
  },
  {
    "text": "Há muito tempo Deus falou muitas vezes e de várias maneiras aos nossos antepassados por meio dos profetas,",
    "reference": "Hebreus 1:1"
  },
  {
    "text": "Mas a respeito do Filho, diz: \"O teu trono, ó Deus, subsiste para todo o sempre; cetro de eqüidade é o cetro do teu Reino.",
    "reference": "Hebreus 1:8"
  },
  {
    "text": "Os anjos não são, todos eles, espíritos ministradores enviados para servir aqueles que hão de herdar a salvação?",
    "reference": "Hebreus 1:14"
  },
  {
    "text": "Por isso é preciso que prestemos maior atenção ao que temos ouvido, para que jamais nos desviemos.",
    "reference": "Hebreus 2:1"
  },
  {
    "text": "Ao levar muitos filhos à glória, convinha que Deus, por causa de quem e por meio de quem tudo existe, tornasse perfeito, mediante o sofrimento, o autor da salvação deles.",
    "reference": "Hebreus 2:10"
  },
  {
    "text": "Porque, tendo em vista o que ele mesmo sofreu quando tentado, ele é capaz de socorrer aqueles que também estão sendo tentados.",
    "reference": "Hebreus 2:18"
  },
  {
    "text": "Portanto, santos irmãos, participantes do chamado celestial, fixem os seus pensamentos em Jesus, apóstolo e sumo sacerdote que confessamos.",
    "reference": "Hebreus 3:1"
  },
  {
    "text": "Vemos, assim, que foi por causa da incredulidade que não puderam entrar.",
    "reference": "Hebreus 3:19"
  },
  {
    "text": "Visto que nos foi deixada a promessa de entrarmos no descanso de Deus, temamos que algum de vocês pense que tenha falhado.",
    "reference": "Hebreus 4:1"
  },
  {
    "text": "Assim, ainda resta um descanso sabático para o povo de Deus;",
    "reference": "Hebreus 4:9"
  },
  {
    "text": "Assim sendo, aproximemo-nos do trono da graça com toda a confiança, a fim de recebermos misericórdia e encontrarmos graça que nos ajude no momento da necessidade.",
    "reference": "Hebreus 4:16"
  },
  {
    "text": "Todo sumo sacerdote é escolhido dentre os homens e designado para representá-los em questões relacionadas com Deus e apresentar ofertas e sacrifícios pelos pecados.",
    "reference": "Hebreus 5:1"
  },
  {
    "text": "Embora sendo Filho, ele aprendeu a obedecer por meio daquilo que sofreu;",
    "reference": "Hebreus 5:8"
  },
  {
    "text": "Mas o alimento sólido é para os adultos, os quais, pelo exercício constante, tornaram-se aptos para discernir tanto o bem quanto o mal.",
    "reference": "Hebreus 5:14"
  },
  {
    "text": "Portanto, deixemos os ensinos elementares a respeito de Cristo e avancemos para a maturidade, sem lançar novamente o fundamento do arrependimento de atos que conduzem à morte, da fé em Deus,",
    "reference": "Hebreus 6:1"
  },
  {
    "text": "Queremos que cada um de vocês mostre essa mesma prontidão até o fim, para que tenham a plena certeza da esperança,",
    "reference": "Hebreus 6:11"
  },
  {
    "text": "onde Jesus, que nos precedeu, entrou em nosso lugar, tornando-se sumo sacerdote para sempre, segundo a ordem de Melquisedeque.",
    "reference": "Hebreus 6:20"
  },
  {
    "text": "Esse Melquisedeque, rei de Salém e sacerdote do Deus Altíssimo, encontrou-se com Abraão quando este voltava, depois de derrotar os reis, e o abençoou;",
    "reference": "Hebreus 7:1"
  },
  {
    "text": "O que acabamos de dizer fica ainda mais claro, quando aparece outro sacerdote semelhante a Melquisedeque,",
    "reference": "Hebreus 7:15"
  },
  {
    "text": "Pois a Lei constitui sumos sacerdotes a homens que têm fraquezas; mas o juramento, que veio depois da Lei, constitui o Filho, perfeito para sempre.",
    "reference": "Hebreus 7:28"
  },
  {
    "text": "O mais importante do que estamos tratando é que temos um sumo sacerdote como esse, o qual se assentou à direita do trono da Majestade nos céus",
    "reference": "Hebreus 8:1"
  },
  {
    "text": "Pois se aquela primeira aliança fosse perfeita, não seria necessário procurar lugar para outra.",
    "reference": "Hebreus 8:7"
  },
  {
    "text": "Chamando \"nova\" esta aliança, ele tornou antiquada a primeira; e o que se torna antiquado e envelhecido, está a ponto de desaparecer.",
    "reference": "Hebreus 8:13"
  },
  {
    "text": "Ora, a primeira aliança tinha regras para a adoração e também um tabernáculo terreno.",
    "reference": "Hebreus 9:1"
  },
  {
    "text": "Por essa razão, Cristo é o mediador de uma nova aliança para que os que são chamados recebam a promessa da herança eterna, visto que ele morreu como resgate pelas transgressões cometidas sob a primeira aliança.",
    "reference": "Hebreus 9:15"
  },
  {
    "text": "assim também Cristo foi oferecido em sacrifício uma única vez, para tirar os pecados de muitos; e aparecerá segunda vez, não para tirar o pecado, mas para trazer salvação aos que o aguardam.",
    "reference": "Hebreus 9:28"
  },
  {
    "text": "A Lei traz apenas uma sombra dos benefícios que hão de vir, e não a realidade dos mesmos. Por isso ela nunca consegue, mediante os mesmos sacrifícios repetidos ano após ano, aperfeiçoar os que se aproximam para adorar.",
    "reference": "Hebreus 10:1"
  },
  {
    "text": "por um novo e vivo caminho que ele nos abriu por meio do véu, isto é, do seu corpo.",
    "reference": "Hebreus 10:20"
  },
  {
    "text": "Nós, porém, não somos dos que retrocedem e são destruídos, mas dos que crêem e são salvos.",
    "reference": "Hebreus 10:39"
  },
  {
    "text": "Pela fé Jacó, à beira da morte, abençoou cada um dos filhos de José e adorou a Deus, apoiado na extremidade do seu bordão.",
    "reference": "Hebreus 11:21"
  },
  {
    "text": "Deus havia planejado algo melhor para nós, para que conosco fossem eles aperfeiçoados.",
    "reference": "Hebreus 11:40"
  },
  {
    "text": "Portanto, também nós, uma vez que estamos rodeados por tão grande nuvem de testemunhas, livremo-nos de tudo o que nos atrapalha e do pecado que nos envolve, e corramos com perseverança a corrida que nos é proposta,",
    "reference": "Hebreus 12:1"
  },
  {
    "text": "Cuidem que ninguém se exclua da graça de Deus. Que nenhuma raiz de amargura brote e cause perturbação, contaminando a muitos.",
    "reference": "Hebreus 12:15"
  },
  {
    "text": "pois o nosso \"Deus é fogo consumidor! ",
    "reference": "Hebreus 12:29"
  },
  {
    "text": "Seja constante o amor fraternal.",
    "reference": "Hebreus 13:1"
  },
  {
    "text": "Portanto, saiamos até ele, fora do acampamento, suportando a desonra que ele suportou.",
    "reference": "Hebreus 13:13"
  },
  {
    "text": "Tiago, servo de Deus e do Senhor Jesus Cristo, às doze tribos dispersas entre as nações: Saudações.",
    "reference": "Tiago 1:1"
  },
  {
    "text": "Cada um, porém, é tentado pela própria cobiça, sendo por esta arrastado e seduzido.",
    "reference": "Tiago 1:14"
  },
  {
    "text": "A religião que Deus, o nosso Pai aceita como pura e imaculada é esta: cuidar dos órfãos e das viúvas em suas dificuldades e não se deixar corromper pelo mundo.",
    "reference": "Tiago 1:27"
  },
  {
    "text": "Meus irmãos, como crentes em nosso glorioso Senhor Jesus Cristo, não façam diferença entre as pessoas, tratando-as com favoritismo.",
    "reference": "Tiago 2:1"
  },
  {
    "text": "De que adianta, meus irmãos, alguém dizer que tem fé, se não tem obras? Acaso a fé pode salvá-lo?",
    "reference": "Tiago 2:14"
  },
  {
    "text": "Assim como o corpo sem espírito está morto, também a fé sem obras está morta.",
    "reference": "Tiago 2:26"
  },
  {
    "text": "Meus irmãos, não sejam muitos de vocês mestres, pois vocês sabem que nós, os que ensinamos, seremos julgados com maior rigor.",
    "reference": "Tiago 3:1"
  },
  {
    "text": "Da mesma boca procedem bênção e maldição. Meus irmãos, não pode ser assim!",
    "reference": "Tiago 3:10"
  },
  {
    "text": "O fruto da justiça semeia-se em paz para os pacificadores.",
    "reference": "Tiago 3:18"
  },
  {
    "text": "De onde vêm as guerras e contendas que há entre vocês? Não vêm das paixões que guerreiam dentro de vocês?",
    "reference": "Tiago 4:1"
  },
  {
    "text": "Entristeçam-se, lamentem e chorem. Troquem o riso por lamento e a alegria por tristeza.",
    "reference": "Tiago 4:9"
  },
  {
    "text": "Pensem nisto, pois: Quem sabe que deve fazer o bem e não o faz, comete pecado.",
    "reference": "Tiago 4:17"
  },
  {
    "text": "Ouçam agora vocês, ricos! Chorem e lamentem-se, tendo em vista a miséria que lhes sobrevirá.",
    "reference": "Tiago 5:1"
  },
  {
    "text": "Como vocês sabem, nós consideramos felizes aqueles que mostraram perseverança. Vocês ouviram falar sobre a paciência de Jó e viram o fim que o Senhor lhe proporcionou. O Senhor é cheio de compaixão e misericórdia.",
    "reference": "Tiago 5:11"
  },
  {
    "text": "lembrem-se disso: Quem converte um pecador do erro do seu caminho, salvará a vida dessa pessoa e fará que muitíssimos pecados sejam perdoados.",
    "reference": "Tiago 5:20"
  },
  {
    "text": "Pedro, apóstolo de Jesus Cristo, aos eleitos de Deus, peregrinos dispersos no Ponto, na Galácia, na Capadócia, na província da Ásia e na Bitínia,",
    "reference": "1 Pedro 1:1"
  },
  {
    "text": "Portanto, estejam com a mente preparada, prontos para a ação; sejam sóbrios e coloquem toda a esperança na graça que lhes será dada quando Jesus Cristo for revelado.",
    "reference": "1 Pedro 1:13"
  },
  {
    "text": "mas a palavra do Senhor permanece para sempre\". Essa é a palavra que lhes foi anunciada.",
    "reference": "1 Pedro 1:25"
  },
  {
    "text": "Livrem-se, pois, de toda maldade e de todo engano, hipocrisia, inveja e toda espécie de maledicência.",
    "reference": "1 Pedro 2:1"
  },
  {
    "text": "Por causa do Senhor, sujeitem-se a toda autoridade constituída entre os homens; seja ao rei, como autoridade suprema,",
    "reference": "1 Pedro 2:13"
  },
  {
    "text": "Pois vocês eram como ovelhas desgarradas, mas agora se converteram ao Pastor e Bispo de suas almas.",
    "reference": "1 Pedro 2:25"
  },
  {
    "text": "Do mesmo modo, mulheres, sujeitem-se a seus maridos, a fim de que, se alguns deles não obedecem à palavra, sejam ganhos sem palavras, pelo procedimento de sua mulher,",
    "reference": "1 Pedro 3:1"
  },
  {
    "text": "Porque os olhos do Senhor estão sobre os justos e os seus ouvidos estão atentos à sua oração, mas o rosto do Senhor volta-se contra os que praticam o mal\".",
    "reference": "1 Pedro 3:12"
  },
  {
    "text": "que subiu ao céu e está à direita de Deus; a ele estão sujeitos anjos, autoridades e poderes.",
    "reference": "1 Pedro 3:22"
  },
  {
    "text": "Portanto, uma vez que Cristo sofreu corporalmente, armem-se também do mesmo pensamento, pois aquele que sofreu em seu corpo rompeu com o pecado,",
    "reference": "1 Pedro 4:1"
  },
  {
    "text": "Cada um exerça o dom que recebeu para servir aos outros, administrando fielmente a graça de Deus em suas múltiplas formas.",
    "reference": "1 Pedro 4:10"
  },
  {
    "text": "Por isso mesmo, aqueles que sofrem de acordo com a vontade de Deus devem confiar suas vidas ao seu fiel Criador e praticar o bem.",
    "reference": "1 Pedro 4:19"
  },
  {
    "text": "Portanto, apelo para os presbíteros que há entre vocês, e o faço na qualidade de presbítero como eles e testemunha dos sofrimentos de Cristo, como alguém que participará da glória a ser revelada:",
    "reference": "1 Pedro 5:1"
  },
  {
    "text": "Sejam sóbrios e vigiem. O diabo, o inimigo de vocês, anda ao redor como leão, rugindo e procurando a quem possa devorar.",
    "reference": "1 Pedro 5:8"
  },
  {
    "text": "Saúdem uns aos outros com beijo de santo amor. Paz a todos vocês que estão em Cristo.",
    "reference": "1 Pedro 5:14"
  },
  {
    "text": "O que era desde o princípio, o que ouvimos, o que vimos com os nossos olhos, o que contemplamos e as nossas mãos apalparam — isto proclamamos a respeito da Palavra da vida.",
    "reference": "1 João 1:1"
  },
  {
    "text": "Se afirmarmos que temos comunhão com ele, mas andamos nas trevas, mentimos e não praticamos a verdade.",
    "reference": "1 João 1:6"
  },
  {
    "text": "Meus filhinhos, escrevo-lhes estas coisas para que vocês não pequem. Se, porém, alguém pecar, temos um intercessor junto ao Pai, Jesus Cristo, o Justo.",
    "reference": "1 João 2:1"
  },
  {
    "text": "Não amem o mundo nem o que nele há. Se alguém amar o mundo, o amor do Pai não está nele.",
    "reference": "1 João 2:15"
  },
  {
    "text": "Se vocês sabem que ele é justo, saibam também que todo aquele que pratica a justiça é nascido dele.",
    "reference": "1 João 2:29"
  },
  {
    "text": "Vejam como é grande o amor que o Pai nos concedeu: que fôssemos chamados filhos de Deus, o que de fato somos! Por isso o mundo não nos conhece, porque não o conheceu.",
    "reference": "1 João 3:1"
  },
  {
    "text": "Meus irmãos, não se admirem se o mundo os odeia.",
    "reference": "1 João 3:13"
  },
  {
    "text": "Os que obedecem aos seus mandamentos permanecem nele, e ele neles. Deste modo sabemos que ele permanece em nós: pelo Espírito que nos deu.",
    "reference": "1 João 3:24"
  },
  {
    "text": "Amados, não creiam em qualquer espírito, mas examinem os espíritos para ver se eles procedem de Deus, porque muitos falsos profetas têm saído pelo mundo.",
    "reference": "1 João 4:1"
  },
  {
    "text": "Amados, visto que Deus assim nos amou, nós também devemos amar-nos uns aos outros.",
    "reference": "1 João 4:11"
  },
  {
    "text": "Ele nos deu este mandamento: Quem ama a Deus, ame também seu irmão.",
    "reference": "1 João 4:21"
  },
  {
    "text": "Todo aquele que crê que Jesus é o Cristo é nascido de Deus, e todo aquele que ama o Pai ama também ao que dele foi gerado.",
    "reference": "1 João 5:1"
  },
  {
    "text": "Filhinhos, guardem-se dos ídolos.",
    "reference": "1 João 5:21"
  }
];
